(() => {
  const eyebrowRules = [
    ['.nk-rotate-hero__index', 'medium'],
    ['.nk-story__label', 'large'],
    ['.nk-story__panel-kicker', 'detail'],
    ['.nk-works-menu__header > p', 'medium'],
    ['.nk-featured-works__eyebrow', 'large'],
    ['.custom-blog-posts .blog-section__eyebrow', 'medium'],
    ['.pricing-details-container .pricing-eyebrow', 'large'],
    ['.pricing-details-container .pricing-section-kicker', 'small'],
    ['.other-services-container .section-title-main', 'large'],
    ['.section-team .profile-eyebrow', 'medium'],
    ['.natsuki-video-gallery__en-title', 'display'],
    ["[id*='section_fQwXQD'] [data-testid='section-content'] > .group-block:first-child h4", 'large'],
    ["[id*='section_yKNmmR'] [data-testid='section-content'] > .group-block:first-child h4", 'medium'],
    ["[id*='section_ttETLV'] [data-testid='section-content'] > .group-block:first-child h4", 'medium'],
    ["[id*='section_k89CJU'] [data-testid='section-content'] > .group-block:first-child h4", 'medium']
  ];

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pendingElements = new Set();
  let frameRequested = false;

  const reveal = (element) => {
    element.classList.add('is-nd-script-visible');
    pendingElements.delete(element);
  };

  const revealVisible = () => {
    frameRequested = false;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    pendingElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top <= viewportHeight * 0.9 && rect.bottom >= viewportHeight * 0.08) {
        reveal(element);
      }
    });
  };

  const scheduleReveal = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(revealVisible);
  };

  const prepare = (element, size) => {
    if (!(element instanceof HTMLElement) || element.dataset.ndScriptReady === 'true') return;

    element.classList.add('nd-script-eyebrow', `nd-script-eyebrow--${size}`);
    element.dataset.ndScriptReady = 'true';

    if (reducedMotion.matches) {
      reveal(element);
      return;
    }

    pendingElements.add(element);
    scheduleReveal();
  };

  const initialize = (scope = document) => {
    eyebrowRules.forEach(([selector, size]) => {
      if (scope instanceof HTMLElement && scope.matches(selector)) prepare(scope, size);
      scope.querySelectorAll?.(selector).forEach((element) => prepare(element, size));
    });
  };

  const start = () => initialize(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:reorder', start);
  window.addEventListener('pageshow', start);
  window.addEventListener('scroll', scheduleReveal, { passive: true });
  window.addEventListener('resize', scheduleReveal, { passive: true });
})();
